import styled, { css } from 'styled-components';
import Accordion from '@mui/material/Accordion';
import { NavLink } from 'react-router-dom';
import { hexToRgba } from 'src/utils';
import { StyledDrawerProps } from '../Layout.styled';

export const StyledList = styled.ul`
  margin: 0 2px;
  overflow-y: auto;
  overflow-x: hidden;
`;

export interface StyledListItemProps {
  $empty?: boolean;
}

export const StyledListItem = styled.li<StyledListItemProps>`
  &:not(:last-child) {
    margin-bottom: 4px;
  }
  ${({ $empty }) => $empty && `user-select: none;`}
`;

export const StyledNavLinkIcon = styled.div<StyledDrawerProps>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 12px;
  transform: scale(0.9);
  width: 28px;
  color: ${(props) => props.theme?.colors.grey1};

  svg {
    transition: color
      ${(props) => `${props.theme?.animation.duration.fast} ${props.theme?.animation.cubicBezier.animateOutFast}`};
  }
`;
export const StyledNavLinkLabel = styled.p<StyledDrawerProps>`
  opacity: ${(props) => (props.$menuIsOpen ? 1 : 0)};
  transition: opacity
    ${(props) => `${props.theme?.animation.duration.fast} ${props.theme?.animation.cubicBezier.animateOutFast}`};
  font-weight: 500;
  color: ${(props) => props.theme?.colors.grey1};
  font-size: 14px;
`;

const navLinkBaseStyles = css`
  border-radius: 4px;
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease-out;
  outline: none;
  border: none;
  background-color: ${(props) => props.theme?.colors.transparent};
  cursor: pointer;

  svg {
    color: ${(props) => props.theme?.colors.grey1};
  }

  &:hover {
    background-color: ${(props) => hexToRgba(props.theme?.colors.grey1 || '', 0.1)};
  }
`;

export const StyledNavLink = styled(NavLink)<{
  $isOverviewPathActive?: boolean;
  $isOverviewPath?: boolean;
}>`
  ${navLinkBaseStyles}

  ${(props) => {
    if (props.$isOverviewPath && !props.$isOverviewPathActive) return css``;

    return css`
      &.active {
        background-color: ${hexToRgba(props.theme?.colors.primary || '', 0.15)};

        ${StyledNavLinkIcon} {
          svg {
            color: ${props.theme?.colors.primary};
          }
        }
        ${StyledNavLinkLabel} {
          color: ${props.theme?.colors.primary};
        }
      }
    `;
  }}
`;

export const StyledExternalNavLink = styled.a`
  ${navLinkBaseStyles}
`;

export const StyledAccordion = styled(Accordion)<{
  $menuIsOpen: boolean;
}>`
  background-color: transparent;
  box-shadow: none;
  padding: 0 !important;
  width: 100% !important;
  border: none !important;
  overflow: hidden;

  &.Mui-expanded {
    margin: 0;
  }

  .MuiAccordionSummary-expandIconWrapper {
    color: ${(props) => props.theme?.colors.grey1};
    display: ${(props) => (props.$menuIsOpen ? 'flex' : 'none')} !important;
  }

  .MuiAccordionSummary-root {
    margin: 0;
    padding: 0;
    min-height: 36px;
    height: 36px;
    border-radius: 4px;
    display: flex;

    transition: background-color
      ${(props) => `${props.theme?.animation.duration.fast} ${props.theme?.animation.cubicBezier.animateOutFast}`};

    &:hover {
      background-color: ${(props) => hexToRgba(props.theme?.colors.grey1 || '', 0.1)};
    }
  }

  .MuiAccordionSummary-content {
    margin: 0;
    width: ${(props) => (props.$menuIsOpen ? '100%' : '74px')} !important;
    overflow: hidden;
    transition: width
      ${(props) => `${props.theme?.animation.duration.fast} ${props.theme?.animation.cubicBezier.animateOutFast}`};

    p {
      opacity: ${(props) => (props.$menuIsOpen ? 1 : 0)} !important;
      width: ${(props) => (props.$menuIsOpen ? '100%' : '0')} !important;

      transition:
        opacity
          ${(props) => `${props.theme?.animation.duration.fast} ${props.theme?.animation.cubicBezier.animateOutFast}`},
        width
          ${(props) => `${props.theme?.animation.duration.fast} ${props.theme?.animation.cubicBezier.animateOutFast}`};
    }
  }

  .MuiAccordionDetails-root {
    svg {
      transform: scale(0.9);
    }
  }
`;
